// Renders an ordered array of content blocks between the heading and the
// question/nav area. Each block is one of:
//   { type: 'text',  value: 'paragraph text', className?: 'custom-class' }
//   { type: 'image', src: importedImage, alt: 'description', className?: 'custom-class' }
//   { type: 'link',  href: 'https://...', label: 'Link text' }
//
// Blocks are rendered in array order, so any sequence works:
//   image > text, text > image, text > image > text, etc.

function ContentBlocks({ blocks }) {
  if (!blocks || blocks.length === 0) return null;

  return (
    <div className="content-blocks">
      {blocks.map((block, i) => {
        if (block.type === 'image') {
          return (
            <img
              key={i}
              src={block.src}
              alt={block.alt || ''}
              className={`block-image ${block.className || ''}`}
            />
          );
        }
        if (block.type === 'text') {
          return (
            <p key={i} className={`block-text ${block.className || ''}`}>
              {block.value}
            </p>
          );
        }
        if (block.type === 'link') {
          return (
            <a key={i} href={block.href} className="block-link" target="_blank" rel="noopener noreferrer">
              {block.label}
            </a>
          );
        }
        return null;
      })}
    </div>
  );
}

export default ContentBlocks;